<template>
  <div>
    stocks
    <ul>
      <li>Marka bazlı sıfır stokta bulunan araç adetlerini gösterir</li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Stocks',
}
</script>
